module.exports = __webpack_public_path__ + "static/Logo-Color-abd56df190da15d3896119d4b7405135.svg";